
import { defineComponent, getCurrentInstance, ref } from 'vue'
import { PropType } from 'vue'

import { CellMouseEvent, Column, getTable, Row } from './types'
import moment from 'moment'
import { getCursor } from './types'
export default defineComponent({
  props: {
    column: {
      type: Object as PropType<Column>,
      required: true
    },
    row: {
      type: Object as PropType<Row>,
      required: true
    },
    rowIndex: {
      type: Number,
      required: true
    },
    columnIndex: {
      type: Number,
      required: true
    },
    disabledCell: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const on = setupEventHandlers(props)
    const instance = getCurrentInstance()
    const $root = (instance?.proxy as any)?.$root
    const cursor = getCursor()
    const isOpenDatePicker = ref(false)

    // Allow cell slot to update input by calling onInput(value)
    const { onInput } = setupInputEvent(props)
    const getDataDisplay = (column: Column, row: Row) => {
      let returnValue = ''
      // Check if column has custom display function
      if (
        column.funcDisplayCellText &&
        typeof column.funcDisplayCellText === 'function'
      ) {
        returnValue = column.funcDisplayCellText(row[column.name], row, column)
      } else if (column.displayField && row[column.name]) {
        returnValue = row[column.name][column.displayField]
      } else if (column.type === 'number') {
        returnValue =
          isNaN(Number(row[column.name])) || Number(row[column.name]) === 0
            ? row[column.name]
            : Number(row[column.name]).toLocaleString('en-US')
      } else if (column.type === 'date' && row[column.name]) {
        returnValue = moment(row[column.name]).format(
          $root.$t('common.time_full_format') as string
        )
      } else {
        returnValue = row[column.name]
      }
      return returnValue
    }
    const isErrorCell = (column: Column, row: Row) => {
      if (!row.redBucket) return false
      return !!row.redBucket.includes(column.name)
    }
    const isMinusCell = (column: Column, row: Row) => {
      if (column.type !== 'number') return false

      const value = row?.[column.name]
      if (value === null || value === undefined || value === '') return false

      const numericValue = Number(value)
      return Number.isFinite(numericValue) && numericValue < 0
    }
    const handleChange = (row: Row, column: Column, $event: string) => {
      isOpenDatePicker.value = false
      row[column.name] = $event
      emit('input', { row: row, column: column, value: $event, cursor: cursor })
    }

    const formatDateDay = (date: string) => {
      if (!props.column.dayFormat) return moment(date).format('D')
      if (typeof props.column.dayFormat === 'function')
        return props.column.dayFormat(date)
      return moment(date).format(props.column.dayFormat)
    }

    const onCheckboxChange = () => emit('checkbox-change', props)
    return {
      on,
      onInput,
      getDataDisplay,
      isErrorCell,
      isMinusCell,
      isOpenDatePicker,
      cursor,
      handleChange,
      formatDateDay,
      onCheckboxChange
    }
  }
})

function setupInputEvent(props: { row: Row; column: Column }) {
  const $table = getTable()
  return {
    onInput($event: any) {
      $table.$emit('input', {
        row: props.row,
        column: props.column,
        value: $event
      })
    }
  }
}

function setupEventHandlers(props: { rowIndex: number; columnIndex: number }) {
  const $table = getTable()

  function onClick($event: MouseEvent) {
    $table.$emit('cellclick', {
      rowIndex: props.rowIndex,
      columnIndex: props.columnIndex,
      $event
    } as CellMouseEvent)
  }

  function onDoubleClick($event: MouseEvent) {
    $table.$emit('celldblclick', {
      rowIndex: props.rowIndex,
      columnIndex: props.columnIndex,
      $event
    } as CellMouseEvent)
  }

  function onContextMenu(event: MouseEvent) {
    event.preventDefault()

    const $event: CellMouseEvent = {
      rowIndex: props.rowIndex,
      columnIndex: props.columnIndex,
      $event: event
    }

    $table.$emit('table.contextmenu', $event)
  }
  function onKeyDown($event: KeyboardEvent) {
    // console.log($event)
  }
  return {
    mousedown: onClick,
    dblclick: onDoubleClick,
    contextmenu: onContextMenu,
    keydown: onKeyDown
  }
}
